import type { CollectionModelFieldSelectList } from '@ikegps/core-shared';
import { MultiListInput } from '../../../components/input/multi.list.input';
import type { MithrilVNode } from '../../../mithril';
import { SelectListChooserState } from '../../multi.list.chooser/select.list.chooser.state';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const SelectListFieldView: CollectionFieldView<CollectionModelFieldSelectList> = {
	viewInline(field: CollectionModelFieldSelectList): string {
		return field.hasValue() ? field.displayValue : null;
	},

	viewDetail(field: CollectionModelFieldSelectList): MithrilVNode {
		return null;
	},

	viewEdit(field: CollectionModelFieldSelectList, ctrl: CollectionEditCtrl): MithrilVNode | string {
		let inputState = ctrl.changeState.getState(field.id) as SelectListChooserState;
		if (inputState == null) {
			inputState = new SelectListChooserState(field);
			inputState.onValue(() => setManualValue(field, inputState));
			ctrl.changeState.addState(field.id, inputState);
		}

		return MultiListInput.view(inputState);
	},
};

function setManualValue(field: CollectionModelFieldSelectList, inputState: SelectListChooserState) {
	const value = inputState.value;

	if (value != null) {
		field.Mutator.manual(value[0]);
	} else {
		field.Mutator.clear();
	}
}
